import React from 'react';
import { Card} from 'react-bootstrap';
import { Table , Row, Col} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';
import PackingCostsMoM from './PackingCostsFoulger';
import PackingCostsVsUnitsShippedMoM from './PackingVsUnitsShippedFoulger'; 
import ShippingCostsVsSalesMoM from './ShippingVsSales'; 
import ShippingCostsVsUnitsShippedMoMFDC from './ShippingVsUnitsShippedFDC'; 

import HandlingVsUnitsShippedBrakesMoM from './HandlingVsUnitsShippedBrakes';


class BillTransactionEntry extends React.Component {


  render() {
  const {transaction, i} = this.props;

  return(
  <tr key={i}>
        <td className="tran-head-med">{DateFnsFormat(parseISO(transaction.submitDate),'yyyy-MM-dd')}</td>
        <td className="tran-head-med">{transaction.contactName}</td>
        <td className="tran-head-med">{transaction.accountCode}</td> 
        <td className="tran-head-med">{transaction.descr}</td> 
        <td className="tran-head-med">{transaction.quantity}</td> 
        <td className="tran-head-med">{transaction.lineAmount}</td>
        <td className="tran-head-med">{transaction.taxAmount}</td>
        <td className="tran-head-med">{transaction.netAmount}</td>
    </tr>
  )
  }
}

class BillTransactionHistory extends React.Component {
    constructor (props) {
      super(props)
      this.handleToChange = this.handleToChange.bind(this);
      this.handleFromChange = this.handleFromChange.bind(this);

    }
    componentDidMount() {
      this.props.fetchBillTransactionFromDate(DateFnsFormat(addDays(new Date(), -14),'yyyy-MM-dd'));

    }

    createDate = (date) =>{
      console.log('date: ' + date  )
       if( date == 'na'){
         return null;
      }else{
        return new Date(parseISO(date));
      }
    }

    handleFromChange(date) {
      this.props.fetchBillTransactionBetweenDates( DateFnsFormat(date, 'yyyy-MM-dd'), this.props.billtransaction.toDate);

    }

    handleToChange(date) {
      this.props.fetchBillTransactionBetweenDates(this.props.billtransaction.fromDate, DateFnsFormat(date, 'yyyy-MM-dd'))
    }

  
         // <ShippingCostsVsSalesMoM id='6' /> removed because of issue

  render() {

    if( this.props.billtransaction.isFetching){
      return (
        <Card className="dashboard"   header="Cost Insights">
         <div className="loader">Loading...</div>
        </Card>
      )
    }
    else{
      return(
        <Card className="dashboard"   header="Cost Insights">
          <PackingCostsMoM id="1" />
          <PackingCostsVsUnitsShippedMoM id='4' />
          <ShippingCostsVsUnitsShippedMoMFDC id='7' />
          <HandlingVsUnitsShippedBrakesMoM id='6' />

          <Row>
        <Col sm="3"><span>from: </span> 
        <DatePicker
                          selected={this.createDate(this.props.billtransaction.fromDate)}
                          onChange={this.handleFromChange}
                          dateFormat="dd-MM-yyyy"
                        />
        </Col>
        
        <Col sm="9"><span>to: </span> 
        <DatePicker
                selected={this.createDate(this.props.billtransaction.toDate)}
                onChange={this.handleToChange}
                dateFormat="dd-MM-yyyy"
                        />
        </Col>
        </Row>    
        <Table className="inv-table" striped bordered  hover>
          <thead>
            <tr>
            <th className="inv-head-med">Date</th>
            <th className="tran-head-med">Contact</th>
            <th className="tran-head-med">Account Code</th>
            <th className="tran-head-med">Descr</th>
            <th className="tran-head-med">Quantity</th>
            <th className="tran-head-med">Line Amount</th>
            <th className="tran-head-med">Tax Amount</th>
            <th className="tran-head-med">Net Amount</th>


            </tr>
          </thead>
          <tbody>
          {
            this.props.billtransaction.lists.map((transaction, i) => <BillTransactionEntry
                                                        key={i} i={i} transaction={transaction} />)
          }
          </tbody>
        </Table>
        </Card>
      )
    }

  }
}

export default BillTransactionHistory;
